import React, { useEffect, useRef, useState } from 'react';
import SiriWave from './siriwave';
import { useDigitalStore } from '@/store/digital';
import styles from './index.module.less';
import { audioRecorder } from '@/pages/DigitalHuman/util/audio-recorder';
interface WaveformProps {
  // frequencyData?: Uint8Array | null;
  colors?: string[];
}

const Waveform: React.FC<WaveformProps> = ({
  // frequencyData = null,
  colors = ["#b48ced", "#4c85f6", "#4c85f6"]
}) => {
  const [frequencyData, setFrequencyData] = useState<Uint8Array | null>(null)

  useEffect(() => {
    audioRecorder.onFrequencyData = (frequencyData: Uint8Array) => {
      setFrequencyData(frequencyData)
    }
  },[])

  const containerRef = useRef<HTMLDivElement>(null);
  const waveRef = useRef<SiriWave | null>(null);
  const animationFrameRef = useRef<number | null>(null);

  // 初始化SiriWave
  useEffect(() => {
    if (containerRef.current && !waveRef.current) {
      waveRef.current = new SiriWave({
        container: containerRef.current,
        width: 1500,
        height: 300,
        style: 'ios9',
        amplitude: 2, // 增加默认振幅
        speed: 0.02,    // 默认速度
        colors: colors,
      });
      waveRef.current.start();
    }

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
      if (waveRef.current) {
        waveRef.current.dispose();
        waveRef.current = null;
      }
    };
  }, []);

  // 使用requestAnimationFrame持续更新波形
  useEffect(() => {
    const updateWaveform = () => {
      if (waveRef.current) {
        if (frequencyData && frequencyData.length > 0) {
          try {
            // 计算频率数据的平均值
            const frequencyArray = Array.from(frequencyData);
            const sum = frequencyArray.reduce((acc, val) => acc + val, 0);
            const average = sum / frequencyArray.length;
            if (average > 10) {
              waveRef.current.setSpeed(0.1);
              waveRef.current.setAmplitude(3);
            } else {
              waveRef.current.setSpeed(0.02);
              waveRef.current.setAmplitude(2);
            }
          } catch (error) {
            // 发生错误时使用默认值
            waveRef.current.setSpeed(0.02);
            waveRef.current.setAmplitude(2);
          }
        } else {
          // 没有频率数据时使用默认值
          waveRef.current.setSpeed(0.02);
          waveRef.current.setAmplitude(2);
        }
      }

      // 下一帧继续更新
      animationFrameRef.current = requestAnimationFrame(updateWaveform);
    };

    // 开始动画循环
    animationFrameRef.current = requestAnimationFrame(updateWaveform);

    // 清理函数
    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
        animationFrameRef.current = null;
      }
    };
  }, [frequencyData]);

  // 处理颜色更新
  useEffect(() => {
    if (waveRef.current) {
      waveRef.current.setColors(colors);
    }
  }, []);

  return <div ref={containerRef} className={styles.waveContainer} />;
};

export default Waveform;
